var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeemgIconsVoicerecord2023(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 28.69C15.7601 28.69 15.5701 28.5 15.5701 28.26V22.94C15.5701 22.7 15.7601 22.51 16.0001 22.51C16.2401 22.51 16.4301 22.7 16.4301 22.94V28.26C16.4301 28.49 16.2401 28.69 16.0001 28.69Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0101 28.6901H12.9901C12.7501 28.6901 12.5601 28.5001 12.5601 28.2601C12.5601 28.0201 12.7501 27.8301 12.9901 27.8301H19.0101C19.2501 27.8301 19.4401 28.0201 19.4401 28.2601C19.4401 28.5001 19.2501 28.6901 19.0101 28.6901Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 23.3601C12.2101 23.3601 9.12012 20.28 9.12012 16.48C9.12012 16.24 9.31012 16.05 9.55012 16.05C9.79012 16.05 9.98012 16.24 9.98012 16.48C9.98012 19.8 12.6801 22.5 16.0001 22.5C19.3201 22.5 22.0201 19.8 22.0201 16.48C22.0201 16.24 22.2101 16.05 22.4501 16.05C22.6901 16.05 22.8801 16.24 22.8801 16.48C22.8801 20.28 19.7901 23.3601 16.0001 23.3601Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 20.8101C13.6001 20.8101 11.6501 18.8601 11.6501 16.4601V7.66006C11.6501 5.26006 13.6001 3.31006 16.0001 3.31006C18.4001 3.31006 20.3501 5.26006 20.3501 7.66006V16.4601C20.3501 18.8601 18.4001 20.8101 16.0001 20.8101ZM16.0001 4.17006C14.0701 4.17006 12.5101 5.74006 12.5101 7.66006V16.4601C12.5101 18.3901 14.0801 19.9501 16.0001 19.9501C17.9301 19.9501 19.4901 18.3801 19.4901 16.4601V7.66006C19.4901 5.74006 17.9301 4.17006 16.0001 4.17006Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeemgIconsVoicerecord2023);
export default __webpack_public_path__ + "static/media/beemg-icons-voicerecord-2023.b8a25a6de93faf61f11bc41db41cbe66.svg";
export { ForwardRef as ReactComponent };